import { defineMessages } from 'react-intl';

const translations = {
  title: {
    id: 'refundDialog.title',
    defaultMessage: 'Refund',
    description: 'title of the refund dialog',
  },
  choosePayment: {
    id: 'refundDialog.choosePayment',
    defaultMessage: 'Choose a payment to refund.',
    description: 'description for choosing payment in the refund dialog',
  },
  chooseAmountToRefund: {
    id: 'refundDialog.chooseAmountToRefund',
    defaultMessage: 'Enter the amount to refund.',
    description: 'description for entering the amount to refund in the refund dialog',
  },
  enterTransactionTotal: {
    id: 'refundDialog.enterTransactionTotal',
    defaultMessage: 'Enter transaction total',
    description: 'label of the button to enter transaction total in the refund dialog',
  },
  fields: {
    amount: {
      id: 'properties.amount',
      defaultMessage: 'Amount',
      description: 'label of the amount field in the refund dialog',
    },
  },
  actions: {
    otherPayment: {
      id: 'refundDialog.actions.otherPayment',
      defaultMessage: 'Other payment',
      description: 'Label of the other payment action in the refund dialog',
    },
    refund: {
      id: 'actions.refund',
      defaultMessage: 'Refund',
      description: 'Label of the other payment action in the refund dialog',
    },
    cancel: {
      id: 'actions.cancel',
      defaultMessage: 'Cancel',
      description: 'Label of the cancel action in the refund dialog',
    },
  },
};

export default defineMessages(translations);
